// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/static/css/async/" + chunkId + "." + {"2086": "c364788c","960": "610dadec","9759": "29dbaee5",}[chunkId] + ".css"
}